import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
var colors = {
  blue: {
    light: '#E0EFFA',
    primary: '#3096DE',
    dark: '#1278B9',
    darker: '#005091',
    darkest: '#0F2F49',
    aqua: {
      10: '#F0FFFF',
      20: '#BBFFFF',
      30: '#7BFFFF',
      40: '#2ADBDB',
      50: '#0CADAD',
      60: '#078181',
      70: '#035F5F',
      80: '#014A4A',
      90: '#004040'
    },
    sky: {
      10: '#F0FCFF',
      20: '#B4F7FF',
      30: '#64E3FF',
      40: '#08C0F9',
      50: '#0098C7',
      60: '#007396',
      70: '#00546E',
      80: '#003E51',
      90: '#003140'
    },
    pale: {
      10: '#F0F9FF',
      20: '#D7EBF7',
      30: '#B7D9ED',
      40: '#84BBDD',
      50: '#4695C5',
      60: '#076AA6',
      70: '#005183',
      80: '#003B5F',
      90: '#002740'
    }
  },
  green: {
    light: '#CCE5A1',
    primary: '#8CC920',
    dark: '#71A31A',
    darker: '#5C8415',
    darkest: '#486710',
    transparent: 'rgba(140, 201, 32, 0.4)',
    soft: {
      10: '#F7FFF0',
      20: '#DAFFB6',
      30: '#93EB3C',
      40: '#75CC21',
      50: '#5CA315',
      60: '#437B0C',
      70: '#315C06',
      80: '#254802',
      90: '#1C3800'
    },
    bold: {
      10: '#EBFFF8',
      20: '#D0FFF2',
      30: '#9CFBDC',
      40: '#54E8B7',
      50: '#06CC8A',
      60: '#138753',
      70: '#006644',
      80: '#005237',
      90: '#00402A'
    }
  },
  red: {
    light: '#F4D9DC',
    primary: '#E22C43',
    dark: '#C2061E',
    darker: '#990013',
    darkest: '#800010',
    transparent: 'rgba(226, 44, 67, 0.15)',
    coral: {
      10: '#FFF5F4',
      20: '#FFE6E2',
      30: '#FFC8C1',
      40: '#FF9C8F',
      50: '#FF6551',
      60: '#CF2F1B',
      70: '#9F1200',
      80: '#700D00',
      90: '#400700'
    }
  },
  pink: {
    baby: {
      10: '#FFEBF4',
      20: '#FAD9E6',
      30: '#F1B9D2',
      40: '#E380AD',
      50: '#CE3E7F',
      60: '#B10854',
      70: '#8D003F',
      80: '#65002D',
      90: '#40001D'
    },
    rosa: {
      10: '#FFF6FB',
      20: '#FFE1F5',
      30: '#FFB7E0',
      40: '#FF7BBA',
      50: '#CA4685',
      60: '#961653',
      70: '#6E0035',
      80: '#520027',
      90: '#38001B'
    }
  },
  orange: {
    tangerine: {
      10: '#FFF7F0',
      20: '#FFDBB3',
      30: '#FFB46C',
      40: '#FF8522',
      50: '#CA5A00',
      60: '#964300',
      70: '#6E3100',
      80: '#522500',
      90: '#381900'
    }
  },
  yellow: {
    light: '#FFF7E1',
    primary: '#FFC736',
    darkest: '#856000',
    golden: {
      10: '#FFFEEB',
      20: '#FFFB94',
      30: '#FCF138',
      40: '#E9B708',
      50: '#CE8605',
      60: '#AD5D03',
      70: '#883C02',
      80: '#612401',
      90: '#401300'
    }
  },
  peach: {
    light: {
      10: '#FFF5E7',
      20: '#FBE8CB',
      30: '#E0C69F',
      40: '#C5A16A',
      50: '#AB7D36',
      60: '#905C0E',
      70: '#754600',
      80: '#5B3600',
      90: '#402600'
    }
  },
  grey: {
    0: '#FFFFFF',
    1: '#FDFDFD',
    2: '#FAFDFF',
    3: '#F7F7F7',
    4: '#F6F9FD',
    5: '#EFF4F6',
    6: '#E0E7EB',
    7: '#BCC3CA',
    8: '#787E85',
    9: '#3A3F43',
    10: '#0E1A24',
    transparent: 'rgba(14, 26, 36, 0.5)',
    cool: {
      0: '#FFFFFF',
      5: '#F7F8FC',
      10: '#EAECF3',
      20: '#D8DAE5',
      30: '#C0C3CF',
      40: '#A2A6B2',
      50: '#828592',
      60: '#646671',
      70: '#4A4C55',
      80: '#363840',
      90: '#292B31',
      100: '#212329'
    }
  },
  violet: {
    ultra: {
      10: '#F6F0FF',
      20: '#E8DAFA',
      30: '#D4BCF3',
      40: '#BA93EE',
      50: '#9B5DEE',
      60: '#7515F5',
      70: '#4C00B2',
      80: '#330076',
      90: '#1C0040'
    },
    lilac: {
      10: '#F4E6FF',
      20: '#ECD3FF',
      30: '#D5ADF4',
      40: '#BA84E2',
      50: '#9B5DC9',
      60: '#793AA9',
      70: '#581E85',
      80: '#3B0A60',
      90: '#240040'
    }
  },
  plum: {
    dark: {
      10: '#F5F0FF',
      20: '#E4DBF8',
      30: '#CEC0EE',
      40: '#B29EDE',
      50: '#9076C8',
      60: '#6A4DA9',
      70: '#452883',
      80: '#290F61',
      90: '#261A40'
    }
  },
  brand: {
    blue: {
      sky: '#A5DEF1',
      bright: '#3096DE',
      medium: '#293B8C',
      dark: '#0F2F49'
    },
    eggshell: '#F5F7FC',
    green: {
      mint: '#86EFCD'
    },
    rich: {
      grey: '#0F1924'
    },
    salmon: '#ED7C83',
    seashell: '#FEF2EF',
    yellow: '#F8EE59'
  }
};
var theme = {
  breakpoints: ['672px', '1056px', '1312px', '1584px'],
  borders: ['0', '1px solid'],
  colors: _objectSpread(_objectSpread({}, colors), {}, {
    state: {
      error: colors.red.primary,
      success: colors.green.primary,
      warning: colors.yellow.primary,
      info: colors.blue.primary
    },
    whitelabel: {
      buttonBackground: colors.grey[7],
      buttonBackgroundHover: colors.grey[8],
      buttonPrimaryBackground: colors.blue.primary,
      buttonPrimaryBackgroundHover: colors.blue.dark,
      buttonPrimaryBackgroundActive: colors.blue.darker,
      headerBackground: colors.grey[0],
      link: colors.blue.primary,
      linkHover: colors.blue.dark,
      menuBackground: colors.grey[0],
      menuBackgroundHover: colors.grey[4],
      text: colors.grey[10]
    }
  }),
  lineHeights: ['16px', '20px', '24px'],
  fonts: {
    body: '"IBM Plex Sans", "Helvetica Neue", Arial, sans-serif'
  },
  fontSizes: {
    0: 12,
    1: 14,
    2: 16,
    3: 18,
    4: 20,
    5: 22,
    6: 46
  },
  fontWeights: {
    light: 300,
    regular: 400,
    bold: 600
  },
  radii: [0, 3],
  corners: {
    cta: '8px',
    pageframe: '8px'
  },
  shadows: {
    elevation: {
      middle: '1px 1px 2px rgba(0, 0, 0, 0.1)',
      top: '0px 2px 4px rgba(0, 0, 0, 0.25)'
    },
    input: 'inset 0px 1px 2px rgba(0, 0, 0, 0.2)'
  },
  space: {
    '-4': -24,
    '-3': -16,
    '-2': -8,
    '-1': -4,
    0: 0,
    1: 4,
    2: 8,
    3: 16,
    4: 24,
    5: 32,
    6: 42,
    7: 48,
    8: 64,
    9: 96,
    10: 160
  }
};
export { theme };